import { render, staticRenderFns } from "./grid-col-widget.vue?vue&type=template&id=31469b92&scoped=true&"
import script from "./grid-col-widget.vue?vue&type=script&lang=js&"
export * from "./grid-col-widget.vue?vue&type=script&lang=js&"
import style0 from "./grid-col-widget.vue?vue&type=style&index=0&id=31469b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31469b92",
  null
  
)

export default component.exports